import React, { useState, useEffect } from 'react'
import { Link } from "react-router-dom"
import FilterItemPieceError from "./filters/FilterItemPieceError"
import ItemPieceErrorTable from "./table/ItemPieceErrorTable"
import { getListFailePieces } from "../../../services/api/3dApi"
import { Pagination } from 'antd'
import { getListBrand } from '../../../services/api/3dApi'


const ItemPieceErrorPage = () => {

    const [name, setName] = useState('')
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(50)
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [partner, setPartner] = useState('')
    const [startCreate, setStartCreate] = useState('')
    const [level, setLevel] = useState('')
    const [user_create, setUser_create] = useState('')
    const [productTypes, setProductTypes] = useState([])
    const [listBatchesError, setListBatchesError] = useState([])
    const [startCuttingAt, setStartCuttingAt] = useState({})
    const [listBrand, setListBrand] = useState([])
    const [brand, setBrand] = useState([])
    const [tags, setTags] = useState([])
    const [batchOvertime, setBatchOvertime] = useState([])

    const _handleChageName = (name) => {
        setName(name)
        setPage(1)
    }

    const _handleChangeProductType = type => {
        setProductTypes(type)
        setPage(1)
    }

    const _handleChageUserCreate = (user) => {
        setUser_create(user)
        setPage(1)
    }

    const _handleChangePartner = partner => {
        setPartner(partner)
        setPage(1)
    }

    const _handleChagePriority = level => {
        setLevel(level)
        setPage(1)
    }

    const _handleChageTags = (field, value) => {
        setTags(value)
        setPage(1)
    }

    const _handleChangeDate = (field, filter) => {
        if(field==='created_at'){
            setStartCreate({ ...filter})
        }
        if(field==='startCuttingAt'){
            setStartCuttingAt({ ...filter[field] })
        }
        setPage(1)
    }

    const _handlePageChange = page => {
        setPage(page)
    }

    const _handleShowSizeChange = (current, size) => {
        setLimit(size)
        setPage(1)
    }

    const _fetchListBatchesError = async () => {

        setLoading(true)
        setError('')

        try {
            const payload = {
                page,
                limit,
            }

            if(!!name) payload.name = name.trim()
            if(!!user_create) payload.user_create = user_create.trim()
            if(!!partner) payload.partner = partner
            if(!!level) payload.level = level
            if(productTypes.length) payload.product_types = productTypes
            if(brand.length) payload.brand = brand
            if(batchOvertime.length) payload.batch_overtime = batchOvertime
            if(tags.length) payload.tags = tags.some(i => i === "FBA") ? [...tags, 'fba'] : tags

            if(startCreate.created_at) payload.created_at = startCreate.created_at
            if(!!Object.keys(startCuttingAt).length) {
                payload.startCuttingAt= startCuttingAt.date
                payload.startCuttingAtTime= startCuttingAt.time
            }

            const {data : response} = await getListFailePieces(payload)
            const {data , success, error} = response
            const {batches, total} = data

            if(!success) return setError(error)

            setListBatchesError(batches || [])
            setLoading(false)
            setTotal(total || 0)

        } catch (e) {
            setError(e.message)
        }finally{
            setLoading(false)
        }
    }

    const _getListBrand = async() => {
        const payload = {
            limit:10000,
            page:1
        }
        try {
            const {data:Data}= await getListBrand(payload)
            const {data, success, message}= Data
            const Brands= data.Brands.map(i=>({value:i.name, label:i.name}))
            if(success){
                setListBrand(Brands)
            }else{
                console.log(message)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const _handleChangeBrand = (value) => {
        setBrand(value)
        setPage(1)
    }

    const _handleChangeBatchOvertime = (field, value) => {
        setBatchOvertime(value)
        setPage(1)
    }

    useEffect(()=> {
        _fetchListBatchesError()
    },[page, limit, name, user_create, partner, startCreate, level, productTypes, startCuttingAt, brand, batchOvertime, tags])

    useEffect(()=> {
        _getListBrand()
    },[])

    return (
        <div className='LabelPage ItemPieceErrorPage'>
            <div className='container-fluid min-vh-100'>
                <div className='col-12 mx-auto bg-white shadow-sm py-3 px-0 px-3'>
                    <div className="mt-3">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h3 className='m-0'>Danh sách lô có items bù chi tiết </h3>
                            <div>
                                <Link
                                    className={`ant-btn`}
                                    to="/batches"
                                >
                                    Quay về danh sách lô
                                </Link>
                            </div>
                        </div>

                        <div className="jumbotron px-3 pb-0 pt-3 mb-3">
                            <FilterItemPieceError
                                partner={partner}
                                level={level}
                                productTypes={productTypes}
                                startCreate={startCreate}
                                listBrand={listBrand}
                                brand={brand}
                                batchOvertime={batchOvertime}
                                handleChangeName={_handleChageName}
                                handleChangeProductType={_handleChangeProductType}
                                handleChageUserCreate={_handleChageUserCreate}
                                handleChangePartner={_handleChangePartner}
                                handleChagePriority={_handleChagePriority}
                                handleChangeDate={_handleChangeDate}
                                handleChangeBrand = {_handleChangeBrand}
                                handleChangeBatchOvertime={_handleChangeBatchOvertime}
                                handleChageTags={_handleChageTags}
                            />
                        </div>

                        <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                            <div>
                                {error && (
                                    <div className="text-danger mb-2">{error}</div>
                                )}
                            </div>
                            <Pagination current={page} total={total} pageSize={limit}
                                showTotal={(sum, range) => sum > 0 &&
                                    <div>{`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total} lô hàng`}</strong>
                                    </div>}
                                onChange={_handlePageChange}
                                className='text-right' showSizeChanger
                                pageSizeOptions={['10', '20', '50', '100']}
                                onShowSizeChange={_handleShowSizeChange} />
                        </div>

                        <div className="LazeCuttingTable">
                            <ItemPieceErrorTable
                                listBatchesError={listBatchesError}
                                loading={loading}
                                onChangeProductType={_handleChangeProductType}
                                refreshBatches={_fetchListBatchesError}
                                handleChangeProductType={_handleChangeProductType}
                                handleChangeBrand={_handleChangeBrand}
                            />
                        </div>

                        <Pagination
                            current={page} total={total} pageSize={limit}
                            onChange={_handlePageChange}
                            showQuickJumper
                            className='CustomPagination text-right' showSizeChanger
                            pageSizeOptions={['10', '20', '50', '100']}
                            onShowSizeChange={_handleShowSizeChange}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ItemPieceErrorPage